import { DestroyRef } from '@angular/core';

export function setTimeoutWithDestroyRef(
  destroyRef: DestroyRef,
  callback: (...args: any[]) => void,
  delay?: number,
  ...args: any[]
): ReturnType<typeof setTimeout> {
  let timeoutId: ReturnType<typeof setTimeout>;
  let unregisterDestroyCallback = () => {};

  timeoutId = setTimeout(() => {
    unregisterDestroyCallback();
    callback(...args);
  }, delay) as unknown as ReturnType<typeof setTimeout>;

  unregisterDestroyCallback = destroyRef.onDestroy(() => clearTimeout(timeoutId));
  return timeoutId;
}
